import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { utilService } from '../../../common/utils';

function LearningGoals({
  goalsReflections,
  onChangeInput,
  learningGoals,
  homeRoomComments,
}) {
  return (
    <>
      <h3 className="font-weight-500 mb-3">Personal Learning Goals</h3>
      <div className="d-flex mb-3">
        <select
          name="selected_year"
          value={goalsReflections.formFields['selected_year'] || ''}
          onChange={onChangeInput}
          className="form-control flex-shrink-0 mr-3 w-auto"
        >
          <option value="">Select Year</option>
          {goalsReflections.years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <select
          name="semester"
          value={goalsReflections.formFields['semester'] || ''}
          onChange={onChangeInput}
          className="form-control flex-grow-1 w-auto"
        >
          <option value="">Select Semester</option>
          {goalsReflections.semesters.map((semester) => (
            <option key={semester} value={semester}>
              {semester}
            </option>
          ))}
        </select>
      </div>
      {learningGoals.length > 0 && (
        <Accordion>
          {learningGoals.map((item) => {
            return item['goal'].map((goals, index) => (
              <Card
                key={index}
                className={cx('rounded-0', {
                  'border-top-0': index > 0,
                })}
              >
                <Accordion.Toggle
                  as={Card.Header}
                  variant="link"
                  eventKey={`g-${index}`}
                  className="py-3 px-4"
                  dangerouslySetInnerHTML={{
                    __html: utilService.htmlDecode(goals),
                  }}
                />
                <Accordion.Collapse eventKey={`g-${index}`}>
                  <Card.Body
                    dangerouslySetInnerHTML={{
                      __html: utilService.htmlDecode(item['reflection'][index]),
                    }}
                  />
                </Accordion.Collapse>
              </Card>
            ));
          })}
        </Accordion>
      )}
      {homeRoomComments.length > 0 && (
        <>
          <h3 className="font-weight-500 mb-3 mt-5">
            Homeroom Teacher Comment
          </h3>
          {homeRoomComments.map((item, index) => (
            <div key={index}>
              <div
                dangerouslySetInnerHTML={{
                  __html: utilService.htmlDecode(item['comment']),
                }}
                className="overflow-auto border p-3 mb-3"
                style={{ height: '300px' }}
              />
              <div className="text-center">
                <p
                  dangerouslySetInnerHTML={{
                    __html: utilService.htmlDecode(item['home_class']),
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: utilService.htmlDecode(item['home_teacher']),
                  }}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
}

LearningGoals.propTypes = {
  goalsReflections: PropTypes.object.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  learningGoals: PropTypes.array.isRequired,
};

export default LearningGoals;
